// ScrollToTop — al cambiar de ruta, scroll instantáneo al inicio.
// React Router preserva el scroll de la página anterior por defecto, lo cual
// confunde en flujos como "abrir detalle de un día" o "ver un tour".
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use both window.scrollTo and documentElement for cross-browser safety
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}
